import * as React from "react";
import { LoaderScreen } from "@grandvisionhq/common";
import { useConfiguratorContext } from "@grandvisionhq/configurator";
import { useDispatch, useIntl, useSelector, statusSuccess } from "@grandvisionhq/state";
import { useRxGlassesConfiguratorContext } from "../../../../context/context/RxGlassesConfiguratorContext.js";
import "../../../../state/state/actions.js";
import "../../../../state/add-to-cart/state/add-to-cart/selectors.js";
import "../../../../state/bundles/state/bundles/selectors.js";
import "../../../../state/bundles/state/bundles/reducer.js";
import { getSelectedFrame, getAddOns, getSelectedAddOn, getAreAddOnsOptional } from "../../../../state/configurator/state/configurator/selectors.js";
import "../../../../state/configurator/state/configurator/reducer.js";
import "../../../../state/products/state/products/selectors.js";
import "../../../../state/products/state/products/reducer.js";
import { getSelectedVariantParentSku } from "../../../../utils/utils/get-selected-variant-parent-sku.js";
import { ProductSelectionStep } from "../../../components/ProductSelectionStep/steps/components/ProductSelectionStep/ProductSelectionStep.js";
import { resetSelectedAddOn, selectAddOn } from "../../../../state/configurations/state/configurations/actions.js";
const LensAddOnStepContainer = () => {
  const dispatch = useDispatch();
  const { getLabel, currency } = useIntl();
  const { goToNextStep } = useConfiguratorContext();
  const { configuratorDocument } = useRxGlassesConfiguratorContext();
  const { readMoreLink } = configuratorDocument?.addOnsStep ?? {};
  const frame = useSelector(getSelectedFrame);
  const addOns = useSelector(getAddOns);
  const selectedAddOn = useSelector(getSelectedAddOn);
  const areAddOnsOptional = useSelector(getAreAddOnsOptional);
  const onChange = React.useCallback(
    (sku) => {
      if (!frame) {
        return;
      }
      if (sku === "") {
        dispatch(
          resetSelectedAddOn({
            frameSku: frame.sku,
            reason: "user selection"
          })
        );
      } else {
        dispatch(
          selectAddOn({
            frameSku: frame.sku,
            addOnSku: sku,
            reason: "user selection"
          })
        );
      }
    },
    [dispatch, frame?.sku]
  );
  if (!statusSuccess(addOns)) {
    return /* @__PURE__ */ React.createElement(LoaderScreen, null);
  }
  const noAddOnOption = {
    variants: [],
    isDefault: false,
    sku: "",
    title: getLabel("products.glasses.lensAddOn.noAddOn.title"),
    description: getLabel("products.glasses.lensAddOn.noAddOn.description"),
    price: {
      originalPrice: 0,
      currency
    }
  };
  let selectedAddOnParentSku = "";
  const addOnsList = areAddOnsOptional ? [...addOns.result, noAddOnOption] : addOns.result;
  if (selectedAddOn) {
    selectedAddOnParentSku = getSelectedVariantParentSku(addOnsList, selectedAddOn?.sku) || selectedAddOn?.sku;
  }
  return /* @__PURE__ */ React.createElement(
    ProductSelectionStep,
    {
      onChange,
      onSubmit: goToNextStep,
      itemsList: addOnsList,
      selectedItemSku: selectedAddOnParentSku,
      readMoreLink,
      step: "lensAddOn"
    }
  );
};
export {
  LensAddOnStepContainer
};
//# sourceMappingURL=LensAddOnStepContainer.js.map
